import { render, staticRenderFns } from "./ClassSchoolRoll.vue?vue&type=template&id=39e49798&scoped=true&"
import script from "./ClassSchoolRoll.vue?vue&type=script&lang=js&"
export * from "./ClassSchoolRoll.vue?vue&type=script&lang=js&"
import style0 from "./ClassSchoolRoll.vue?vue&type=style&index=0&id=39e49798&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e49798",
  null
  
)

export default component.exports